/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import {FetchMethod} from '@dvrd/dvr-controls';

export const URLS = {
    [FetchMethod.GET]: {
        USER: '',
        LOGOUT: '',
        DISABLE_TWO_FACTOR: '',
        GENERATE_TWO_FACTOR: '',
    },
    [FetchMethod.POST]: {
        LOGIN: '',
        USER: '',
        VALIDATE_TWO_FACTOR: '',
        REGISTER: '',
        CONTACT: 'contact'
    },
    [FetchMethod.PUT]: {
        USER: '',
    },
    [FetchMethod.DELETE]: {
        USER: '',
    },
};